export function arrayWrap<T>(values: T | T[]): T[] {
    return Array.isArray(values) ? values : [values];
}
